import { render, staticRenderFns } from "./last-diagnostic-detail.vue?vue&type=template&id=6a2eefbe&"
import script from "./last-diagnostic-detail.vue.js?vue&type=script&lang=js&"
export * from "./last-diagnostic-detail.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports